import { FIELD_VIEWERS, mergePrehydrationValues, normalizeLoadedFormValues, prunePrehydrationValues } from '@wix/form-fields';
import { deepEqual } from 'fast-equals';
import { useEffect, useMemo, useReducer, useRef } from 'react';
import { autofillValues } from '../../components/form/autofill';
import { fillEmptyValues } from '../form-values';
// eslint-disable-next-line max-params
export const useFormValues = (form, values, onChange, userData, addressTemplates, enableAutofill, prehydrationValues)=>{
    const hasAutofilled = useRef(false);
    const normalizedValues = useMemo(()=>{
        let filled = fillEmptyValues(form, values);
        if (enableAutofill && !hasAutofilled.current && userData) {
            hasAutofilled.current = true;
            filled = autofillValues(form, filled, userData);
        }
        return normalizeLoadedFormValues(FIELD_VIEWERS, form, filled, true, addressTemplates);
    }, [
        form,
        values,
        userData,
        addressTemplates,
        enableAutofill
    ]);
    const [, rerenderWithPrehydrationText] = useReducer((renders)=>renders + 1, 0);
    const pendingCount = prehydrationValues?.current.size ?? 0;
    const renderedPendingCount = useRef(pendingCount);
    renderedPendingCount.current = pendingCount;
    const valuesWithPrehydrationText = useMemo(()=>pendingCount > 0 && prehydrationValues ? mergePrehydrationValues(normalizedValues, prehydrationValues.current) : normalizedValues, [
        normalizedValues,
        pendingCount,
        prehydrationValues
    ]);
    useEffect(()=>{
        const pending = prehydrationValues?.current;
        if (pending?.size) {
            prunePrehydrationValues(values ?? {}, pending);
        }
        const merged = pending?.size ? mergePrehydrationValues(normalizedValues, pending) : normalizedValues;
        const hasAnyValueChanged = !deepEqual(merged, values);
        if (hasAnyValueChanged) {
            onChange?.(merged);
        }
        if ((pending?.size ?? 0) !== renderedPendingCount.current) {
            rerenderWithPrehydrationText();
        }
    }, [
        values,
        normalizedValues,
        onChange,
        prehydrationValues
    ]);
    return valuesWithPrehydrationText;
};

//# sourceMappingURL=use-form-values.js.map